import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@utils/cn";
import { forwardRef } from "react";

const Progress = forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-1 w-full overflow-hidden bg-azure-radiance-100",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full bg-mint-green-500 transition-all"
      style={{ width: `${value || 0}%` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
